function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const StarIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9l3.8 2.3-1-4.3L16.1 9l-4.4-.4-1.7-4-1.7 4-4.4.4 3.3 2.9-1 4.3 3.8-2.3zm10-6.2l-5.4 4.7 1.6 7-6.2-3.7-6.2 3.8 1.6-7L0 7.7l7.2-.6L10 .5l2.8 6.6 7.2.6z"
  }));
};
export default StarIcon;